export default "__VITE_ASSET__jnjYVXRb__"